import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'Components/Button';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import './GDRowActions.scss';

const GDRowActions = ({ actions, getMerchantActions, isMerchatActions, caseStageId, extraClass, triggerText, rowIndex, rowActionClick, isCaseSelection, extraWidth, openBoxDropDownStyle, rowLength, elementRefrence, setScroll, isTakeActionButton, isOpen, onCloseClick, isGridCompact, reportName, isActionClick, isArchival}) => {
  const wrapperClass = classnames('row-actions', {
    [extraClass]: extraClass,
  });

  const [actionsList, setActionsList] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);

  const compare=(action1, action2)=>{
    const displayOrder1=parseInt(action1.displayOrder,10);
    const displayOrder2=parseInt(action2.displayOrder,10);
    if(displayOrder1>displayOrder2)
      return 1
    else if(displayOrder1<displayOrder2) 
      return -1
    return 0
  }

  const getActionsList = () => {
    if (isMerchatActions) {
      setIsFetchingData(true)
      getMerchantActions(caseStageId, true,isArchival)
        .then(response => {
          setIsFetchingData(false)
          let tempData=response.data;
          tempData.sort(compare);
          setActionsList(tempData)
         
        })
        .catch(error => {
          setIsFetchingData(false);
          console.log("Error Occured while fetching actions", error)
        })
    }
  }
  return (
    <div className={reportName == 'MRE' ? "" : isCaseSelection && isGridCompact ? 'action-popup-wrapper-compact' : 'action-popup-wrapper'}>
      <OptionBoxPopup
        isButtonCompact={isGridCompact}
        id="row-actions"
        className="action-popup"
        getActionsList={() => getActionsList()}
        isMerchatActions={isMerchatActions}
        triggerText={triggerText}
        extraWidth={extraWidth}
        openBoxDropDownStyle={openBoxDropDownStyle}
        rowLength={rowLength}
        elementRefrence={elementRefrence}
        setScroll={setScroll}
        rowIndex={rowIndex}
        isOpen={isOpen}
        onCloseClick={onCloseClick}
        reportName = {reportName}
        isActionClick = {isActionClick}
      >
        {isMerchatActions && !isFetchingData &&
          actionsList.map((action, key) => {
            const ua = window.navigator.userAgent;
            const isIE = ua.indexOf('Trident/') || ua.indexOf('MSIE');
            let defaultClass = isIE > 0 ? "link smallIE" : "link small";
            let category = action.actionCode ===
              'AL' ? defaultClass.concat(" accept") : defaultClass;
            let extraClass = isMerchatActions && 'button-link-pad';
            return (
              <Button
                id ={action.actionName.split(" ").join("")}
                action={() => rowActionClick(rowIndex, action.actionCode)}
                category={category}
                key={key}
                extraClass={extraClass}
              >
                {action.actionName}
              </Button>
            );
          })

        }
        {
          !isMerchatActions && actions && actions.map((action, key) => {
            return (
              <Button
                id ={action.title.split(" ").join("")}
                action={() => rowActionClick(rowIndex, action.key)}
                category="link small"
                key={key}
                style={action.style !== undefined && !isIE ? action.style : {}}
               
              >
                {reportName == 'MRE' ? <span style={{justifyContent:"left",marginLeft:"-10px"}}>{action.title}</span> : action.title}
              </Button>
            );
          })

        }
        {isMerchatActions && isFetchingData &&  <div className="action-loader"><BVLoader20 /></div>}
      </OptionBoxPopup>
    </div>

  );
};


GDRowActions.propTypes = {
  actions: PropTypes.array.isRequired,
  extraClass: PropTypes.string,
  triggerText: PropTypes.string.isRequired,
  actionName: PropTypes.string,
  rowActionClick: PropTypes.func,
  extraWidth: PropTypes.bool,
  setScroll: PropTypes.func,
  onCloseClick: PropTypes.bool,
  reportName: PropTypes.string,
  isActionClick: PropTypes.bool,
  isGridCompact: PropTypes.bool,
  isGridLandingRelatedOpen : PropTypes.bool
};

GDRowActions.defaultProps = {
  extraClass: '',
  actionName: 'View Details',
  setScroll: () => { },
  onCloseClick: false,
  reportName: '',
  isActionClick: false,
  isGridCompact: false
};

export default GDRowActions;
